"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Video = createSVGIcon(
  <>
    <rect x=".5" y=".5" width="17" height="17" rx=".5" stroke="currentColor" />
    <path
      d="M18.178 9.323a.15.15 0 0 1 0-.246l5.587-3.87a.15.15 0 0 1 .235.122v7.741a.15.15 0 0 1-.235.124z"
      stroke="currentColor"
    />
  </>,
  "Video",
  {
    viewBox: "0 0 26 18",
    titleAccess: "Video",
    fill: "none",
    className: legacyIconCls(),
  }
);
